import { useEffect, useContext } from "react";

import PermissionContext from "../../../context/PermissionContext";
import DrawerContext from "../../../context/DrawerContext";
import AutoLogout from "../../../utils/useAutoLogout";
import LipidRawMaterialContext from "../../../context/materialcapture/LipidRawMaterialContext";

import SideDrawer from "../../../components/layout/SideDrawer";
import SuccessAlert from "../../../components/layout/SuccessAlert";
import Loader from "../../../components/layout/Loader";
import ErrorModal from "../../../components/layout/ErrorModal";
import TopBarWithBack from "../../../components/layout/TopBarWithBack";
import LipidRawMaterialForm from "../../../components/materialscapture/LipidRawMaterialForm";
import LipidAliquotForm from "../../../components/materialscapture/LipidAliquoteForm";
import RawMaterialsFooter from "../../../components/materialscapture/RawMaterialFooter";

const LipidRawMaterialEditPage = () => {
  const { permisionsList, checkUserPermission } = useContext(PermissionContext);
  const { drawerValue, setDrawerValue } = useContext(DrawerContext);
  const { 
    lipidAliquotsArray, handleAliquoteAdd, handleSubmit, 
    setLipidRawMaterialId, apiRes, setApiRes 
  } = useContext(LipidRawMaterialContext);

  const backURL = '/lipid-raw-materials';

  useEffect(() => {
    const docUrIArr = window.location.href.split('/');
    setLipidRawMaterialId(docUrIArr[docUrIArr.length - 1]);
  }, []); 

  useEffect(() => {
    if(permisionsList.length > 0) checkUserPermission(['Materials Capture-Lipid Raw Materials']);
  }, [permisionsList]);

  return(
    <AutoLogout>
      <SideDrawer drawerValue={drawerValue} setDrawerValue={setDrawerValue} />
      {apiRes.loading && <Loader />}
      <div className="mainContainer" style={{ marginLeft: drawerValue.drawerWidth }}>
        {apiRes.showAlert && <SuccessAlert apiRes={apiRes} setApiRes={setApiRes} />}
        <TopBarWithBack title={'Lipid Raw Material Edit'} backURL={backURL} />
        <LipidRawMaterialForm />
        {
          lipidAliquotsArray.map((data, index) => (
            <LipidAliquotForm key={index} index={index} data={data} />
          ))
        }
        <RawMaterialsFooter 
          btnText={'Aliquot'} 
          handleAdd={handleAliquoteAdd} 
          handleSubmit={handleSubmit} 
        />
        <ErrorModal apiRes={apiRes} setApiRes={setApiRes} />
      </div>
    </AutoLogout>
  );
};

export default LipidRawMaterialEditPage;